<template>
  <div>
    <LazyDialog v-if="shouldShow" />
    <ClientOnly>
      <LazyToastGroup />
    </ClientOnly>
    <LazyLegacyDrawerTransition>
      <LazyLegacyDrawer
        v-if="shouldShowDrawer" />
    </LazyLegacyDrawerTransition>

    <ClientOnly>
      <LazyCartTransition>
        <LazyCartMini v-if="cartStore.show" />
      </LazyCartTransition>
    </ClientOnly>

    <div>
      <GlobalModals />
    </div>
    <ToolbarMain
      ref="toolbar"
      :transparent="isHomePage"
      :aria-hidden="showStickyToolbar && isHomePage"
      :is-hidden="showStickyToolbar && isHomePage" />
    <ToolbarMain
      v-if="isHomePage"
      :aria-hidden="!showStickyToolbar && isHomePage"
      :is-hidden="!showStickyToolbar && isHomePage"
      :class="[
        $style['sticky-toolbar'],
        { [$style['sticky-toolbar--active']]: showStickyToolbar }
      ]" />
    <main
      :class="[
        {'main--no-padding': isHomePage }
      ]">
      <slot />
    </main>

    <IntersectionObserver>
      <LazyFooter
        v-if="rootStore.showFooter"
        :inset-left="rootStore.footerInsetLeft" />
    </IntersectionObserver>
    <ClientOnly>
      <LazyLangSwitcher v-if="rootStore.showLanguageSwitcher" />
      <LazyTrustBadge v-if="$lang === 'de'" />
    </ClientOnly>
  </div>
</template>
<script setup>

await useCart()
await useWishlist()
const rootStore = useRootStore()
const cartStore = useCartStore()
const { shouldShow } = useDialog()
const { shouldShow: shouldShowDrawer } = useDrawer()
const { isHomePage } = useHomePage()
const observer = ref(null)
const showStickyToolbar = ref(false)
const toolbar = ref()
let topOfScreen = 150

const onIntersect = event => {
  showStickyToolbar.value = !event[0].isIntersecting
  showStickyToolbar.value = (window.scrollY > topOfScreen)
}

onMounted(() => {
  topOfScreen = window.innerWidth < 1350 ? 150 : 250
  const rootMargin = `${topOfScreen}px`
  observer.value = new IntersectionObserver(onIntersect, { rootMargin, threshold: 1 })
  observer.value.observe(toolbar.value.$el)
})

onUnmounted(() => {
  if (observer.value) {
    observer.value.disconnect()
    observer.value = null
  }
})

</script>

<style lang="scss" module>
.sticky-toolbar {
  header {
    transform: translateY(calc(-1 * var(--toolbar-height)));
    transition: .3s ease-in-out;
  }

  &--active {
    header {
      transform: none;
    }
  }
}

.card-container {
  display: flex;
  gap: calc(var(--spacing) * 2);
  flex-wrap: wrap;

  > *:not(a) {
    width: calc(100% / 3 - var(--spacing) * 2 * (2 / 3));

    @media (max-width: #{$breakpoint-mobile}){
      width: calc(50% - var(--spacing) * 2 * (1 / 2));
    }
  }

}

.button-container {
  display: flex;
  justify-content: space-between;
  max-width: 250px;
  margin: calc(var(--spacing) * 6) auto calc(var(--spacing) * 2);
}

</style>
